export default __webpack_public_path__ + "ddae9b1ba9b0b42f58809904b0b21349.woff";